<template>
    <lista-conversas-base
        tabela-id="tblMensEnviadas"
        modal-id="modal-conversa-enviada"
        :conversas="conversas"
        :campos="campos"
        :itens-por-pagina="itensPorPagina"
        :carregando="carregando"
        :conversa-ativa="conversaAtiva"
        :participantes="participantes"
        :deve-exibir-participantes="deveExibirParticipantes"
        :usuario-id="usuarioId"
        :usuario="usuario"
        @abrir-conversa="abrirConversa"
        @modal-hidden="fecharConversa"
        @novas-mensagens="atualizarContadorNovasMensagens"
        @mensagens-marcadas-como-lidas="onMensagensMarcadasComoLidas"
    />
</template>

<script>
import { ConversasMixin } from './mixins/ConversasMixin'
import ListaConversasBase from './components/ListaConversasBase.vue'

export default {
    mixins: [ConversasMixin],

    components: {
        ListaConversasBase
    },

    props: {
        deveCarregar: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'usuarioCriacao',
                    label: 'Enviada por',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'assunto',
                    label: 'Assunto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'usuarioEmAtendimento',
                    label: 'Em Atendimento',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataCriacao',
                    label: 'Criada em',
                    sortable: true,
                    formatter: value => this.formatarData(value),
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ]
        }
    },

    computed: {
        modalId() {
            return 'modal-conversa-enviada'
        },

        tabelaId() {
            return 'tblMensEnviadas'
        }
    },

    async created() {
        await this.inicializarConexaoHub()
        if (this.deveCarregar) {
            this.carregarConversas()
        }
    },

    watch: {
        deveCarregar: {
            immediate: false,
            handler(novoValor) {
                if (novoValor && this.conversas.length === 0) {
                    this.carregarConversas()
                }
            }
        }
    },

    methods: {
        onConversasEnviadasCarregadas(novasConversas) {
            this.onConversasCarregadas(novasConversas)
        }
    }
}
</script>
